import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "py-5 d-flex justify-content-center align-items-center" }
const _hoisted_3 = { class: "w-100" }
const _hoisted_4 = { class: "create-location-dropzone create-location-dropzone--545 ratio-60" }
const _hoisted_5 = { class: "drag-and-drop-wrapper" }
const _hoisted_6 = { class: "w-100 mt-4 d-flex flex-column align-items-center" }
const _hoisted_7 = { class: "upload-text text-center w-100" }
const _hoisted_8 = { class: "light-text" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "font-15 w-100 mt-3" }, " Recommended size: less than 10 MB ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "font-15 w-100" }, "Format: PNG JPG JPEG", -1)
const _hoisted_11 = { class: "mt-3 pt-1" }
const _hoisted_12 = {
  for: "category-active",
  class: "d-flex align-items-center cursor-pointer"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "d-block ms-2" }, "Active", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DragAndDrop = _resolveComponent("DragAndDrop")!
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_AutosizeTextarea = _resolveComponent("AutosizeTextarea")!
  const _component_AppInputsValidationProvider = _resolveComponent("AppInputsValidationProvider")!
  const _component_AppCheckbox = _resolveComponent("AppCheckbox")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_TabsDialog = _resolveComponent("TabsDialog")!

  return (_openBlock(), _createBlock(_component_TabsDialog, {
    key: 1,
    modelValue: _ctx.selectedTab,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedTab) = $event)),
    tabs: _ctx.tabs,
    title: _ctx.title,
    opened: _ctx.opened,
    onHide: _ctx.hide,
    class: "create-location-modal"
  }, {
    "modal-button": _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_AppButton, {
          disabled: !_ctx.disabledButton,
          type: "secondary",
          size: "xl",
          loading: _ctx.loading,
          onClick: _ctx.submit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.title), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_DragAndDrop, {
                  key: "image",
                  "area-icon": "camera",
                  accepted: ['png', 'jpg', 'jpeg'],
                  placeholder: _ctx.image,
                  onFileChanged: _cache[0] || (_cache[0] = 
                  (file) => {
                    _ctx.setImage(file);
                  }
                )
                }, null, 8, ["placeholder"])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, "Please, upload " + _toDisplayString() + " Image", 1),
                _hoisted_9,
                _hoisted_10
              ])
            ])
          ])
        ]),
        (_openBlock(), _createBlock(_component_AppInputsValidationProvider, {
          key: 2,
          "shake-tre": _ctx.disabledButton,
          onChangeErrorState: _ctx.onChangeErrorState
        }, {
          default: _withCtx(() => [
            _createVNode(_component_AppInput, {
              id: "title-page",
              modelValue: _ctx.editData.h1,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editData.h1) = $event)),
              "input-type": "material",
              label: "H1",
              type: "text",
              name: "title-page",
              validationType: "notEmptyString"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_AutosizeTextarea, {
              id: "title-body",
              modelValue: _ctx.editData.body,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editData.body) = $event)),
              "input-type": "material",
              label: "Body",
              type: "text",
              isTextarea: true,
              isAutoSize: true,
              name: "title-description"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["shake-tre", "onChangeErrorState"]))
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.isHomePage? '' : 'pt-5')
      }, [
        (_openBlock(), _createBlock(_component_AppInputsValidationProvider, {
          key: 1,
          "shake-tre": _ctx.disabledButton,
          onChangeErrorState: _ctx.onChangeErrorState
        }, {
          default: _withCtx(() => [
            _createVNode(_component_AppInput, {
              id: "title-seo",
              modelValue: _ctx.editData.title,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editData.title) = $event)),
              "input-type": "material",
              label: "Title",
              type: "text",
              required: false,
              name: "title-seo"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_AutosizeTextarea, {
              id: "title-description",
              modelValue: _ctx.editData.description,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editData.description) = $event)),
              "input-type": "material",
              label: "Description",
              type: "text",
              isTextarea: true,
              isAutoSize: true,
              required: false,
              name: "title-description"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_AppInput, {
              id: "Keywords-seo",
              modelValue: _ctx.editData.keywords,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editData.keywords) = $event)),
              "input-type": "material",
              label: "Keywords",
              type: "text",
              required: false,
              name: "Keywords-seo"
            }, null, 8, ["modelValue"]),
            (!_ctx.isHomePage)
              ? (_openBlock(), _createBlock(_component_AppInput, {
                  key: 0,
                  id: "page-path",
                  modelValue: _ctx.editData.path,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editData.path) = $event)),
                  "input-type": "material",
                  label: "path",
                  type: "text",
                  required: false,
                  name: "image"
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            _createVNode(_component_AutosizeTextarea, {
              id: "title-body",
              modelValue: _ctx.editData.SEO_block,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editData.SEO_block) = $event)),
              "input-type": "material",
              label: "SEO block",
              type: "text",
              isTextarea: true,
              isAutoSize: true,
              name: "title-description"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["shake-tre", "onChangeErrorState"])),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("label", _hoisted_12, [
            _createVNode(_component_AppCheckbox, {
              id: "category-active",
              modelValue: _ctx.editData.active,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editData.active) = $event)),
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.editData.active = _ctx.isChecked))
            }, null, 8, ["modelValue"]),
            _hoisted_13
          ])
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["modelValue", "tabs", "title", "opened", "onHide"]))
}